import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

interface NavItem {
    label: string;
    path?: string;
    children?: { label: string; path: string }[];
}

interface Props {
    onLinkClick: () => void;
}

const NavbarItems: React.FC<Props> = ({ onLinkClick }) => {
    const { userRole, authReady } = useSelector((state: RootState) => state.auth);
    const isAdmin = authReady && userRole === "admin";
    const [expandedItem, setExpandedItem] = useState<string | null>(null);

    const handleAccordionChange = (label: string) => {
        setExpandedItem(prev => (prev === label ? null : label));
    };

    const items: NavItem[] = [
        { label: "Inicio", path: "/" },
        ...(isAdmin ? [{
            label: "Personal",
            children: [
                { label: "Ideas", path: "/ideas" },
                { label: "Viajes", path: "/viajes" },
                { label: "Ranking", path: "/ranking" },
                { label: "Recetas", path: "/recetas" },
                { label: "Galería de Fotos", path: "/galeria" }
            ]
        }] : []),
        {
            label: "Utilidades",
            children: [
                { label: "Ruleta de Ganadores", path: "/ganador-aleatorio" },
                { label: "Generar equipos", path: "/generar-equipos" },
                { label: "Calculadora Forex", path: "/calculadora-forex" }
            ]
        },
        ...(isAdmin ? [{
            label: "Juegos",
            children: [
                { label: "Sopa de Letras", path: "/sopa-de-letras" }
            ]
        }] : []),
        { label: "Correos", path: "/correos" },
        { label: "Acerca", path: "/acerca" },
        { label: "Contacto", path: "/contacto" }
    ];

    return (
        <List>
            {items.map((item) =>
                item.children ? (
                    <Accordion
                        key={item.label}
                        expanded={expandedItem === item.label}
                        onChange={() => handleAccordionChange(item.label)}
                        disableGutters
                        elevation={0}
                        sx={{ bgcolor: "transparent" }}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>{item.label}</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ pl: 2, pr: 0, pt: "2px" }}>
                            <List disablePadding>
                                {item.children.map((child) => (
                                    <ListItem key={child.label} disablePadding>
                                        <ListItemButton
                                            component={Link}
                                            to={child.path}
                                            onClick={onLinkClick}
                                            style={{ padding: "6px 16px" }}
                                        >
                                            <ListItemText primary={child.label} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <ListItem key={item.label} disablePadding>
                        <ListItemButton component={Link} to={item.path!} onClick={onLinkClick}>
                            <ListItemText primary={item.label} />
                        </ListItemButton>
                    </ListItem>
                )
            )}
        </List>
    );
};

export default NavbarItems;
